import React from 'react';
import { useNavigation } from '../hooks/useNavigation';

interface PaginationProps {
  nbPages: number;
  page: number;
  path: string;
}

const Pagination: React.FC<PaginationProps> = ({ nbPages, page, path }) => {
  const { goTo } = useNavigation();
  const renderPagination = () => {
    const pages: JSX.Element[] = [];
    if (nbPages <= 9) {
      for (let i = 1; i <= nbPages; i++) {
        pages.push(
          <button
            className="mx-1 text-blue-500 hover:underline"
            key={i}
            onClick={() => goTo(path + '/' + i)}
            style={{ fontWeight: page === i ? 'bold' : 'normal' }}
          >
            {i}
          </button>
        );
      }
    } else {
      pages.push(
        <button className="mx-1 text-blue-500 hover:underline" key={1} onClick={() => goTo(path + '/1')} style={{ fontWeight: page === 1 ? 'bold' : 'normal' }}>
          1
        </button>
      );
      if (page > 3) {
        pages.push(<span key="left-ellipsis">...</span>);
      }

      const startPage = Math.max(2, page - 1);
      const endPage = Math.min(nbPages - 1, page + 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <button
            className="mx-1 text-blue-500 hover:underline"
            key={i}
            onClick={() => goTo(path + '/' + i)}
            style={{ fontWeight: page === i ? 'bold' : 'normal' }}
          >
            {i}
          </button>
        );
      }

      if (page < nbPages - 2) {
        pages.push(<span key="right-ellipsis">...</span>);
      }

      pages.push(
        <button className="mx-1 text-blue-500 hover:underline" key={nbPages} onClick={() => goTo(path + '/' + nbPages)} style={{ fontWeight: page == nbPages ? 'bold' : 'normal' }}>
          {nbPages}
        </button>
      );
    }
    return pages;
  };

  return <div>{renderPagination()}</div>;
};

export default Pagination;